import { DeleteSerialNumberModalProps } from "./types";
import { Box, Stack, Text } from "@mantine/core";
import { ModalComponent } from "components";
import { loadingComplete, showLoading } from "utils/loader";
import { net } from "utils/net";

import { useAuth } from "providers/auth";
import { useState } from "react";

export function DeleteSerialNumberModal(props: DeleteSerialNumberModalProps) {
  const { context, id, innerProps } = props;
  const { serialNumber, onSubmit } = innerProps;
  const { accessToken } = useAuth();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!accessToken) return;

    try {
      showLoading("serial-number.delete");
      setIsLoading(true);
      const relativeUrl = `/serial-numbers/${serialNumber.id}`;
      const netInstance = net(accessToken);
      await netInstance.delete(relativeUrl);
      if (onSubmit) await onSubmit();

      context.closeModal(id);
      loadingComplete("serial-number.delete", false);
    } catch (err) {
      loadingComplete("serial-number.delete", true);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Stack>
        <Box>
          <Text>
            Your <strong>{serialNumber.serialNumber}</strong> serial number will
            be deleted. Please note that you can not recover the deleted serial
            number.
          </Text>
        </Box>
        <ModalComponent.ActionButtons
          context={context}
          id={id}
          submit={{ label: "Delete", disabled: isLoading }}
        />
      </Stack>
    </form>
  );
}
